<ce-tile-basic
    [title]="alerts?.length > 0 ? needsAttention : statusOK"
    [loading]="loading"
    (openDialog)="openAlertHistory()"
>
    <ng-container tile-content>
        <div class="settings fx-column" *ngIf="displayAlerts?.length > 0">
            <div class="alert" *ngFor="let alert of displayAlerts; trackBy: trackByAlert">
                <ce-alert-badge
                    [displayStation]="!stationId"
                    [alert]="alert"
                    [severityIcon]="getSeverityIconForAlert(alert)"
                ></ce-alert-badge>
            </div>
        </div>
        <div class="fx-align-start-center fx-layout-gap-8 fx-row" *ngIf="!loading && alerts?.length === 0">
            <mat-icon svgIcon="check" class="success"></mat-icon>
            <div i18n="Status alert title|">No open issues</div>
        </div>
    </ng-container>
</ce-tile-basic>
